export function BarOptions (isMobile) {
    return {
        legend: {
            display: false
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
            yAxes: [
                {
                    ticks: {
                        fontColor: '#062B54',
                        fontSize: 14,
                        padding: isMobile ? 8 : 24
                    },
                    gridLines: {
                        display: false
                    }
                }
            ],
            xAxes: [
                {
                    ticks: {
                        fontColor: '#062b548a',
                        fontSize: 12,
                        beginAtZero: true,
                        stepSize: 100
                    },
                    gridLines: {
                        display: false
                    }
                }
            ]
        }
    };
}
